export default __webpack_public_path__ + "static/android-chrome-512x512-37973593890283e6a69eb174f0c53b94.png";